import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { approveOrganizationRequestThunk } from '../thunks/approval-request.thunks'

export type approveOrganizationRequestState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: approveOrganizationRequestState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const approveOrganizationRequestSlice = createSlice({
  name: 'approveOrganizationRequestSlice',
  initialState: initialState,
  reducers: {
    resetApproveOrganizationRequest: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
      // (state.organizations = {} as OrganizationResponseTypes)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveOrganizationRequestThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(approveOrganizationRequestThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.requestResponse.data = action.payload
      })
      .addCase(approveOrganizationRequestThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetApproveOrganizationRequest } = approveOrganizationRequestSlice.actions
export default approveOrganizationRequestSlice.reducer
